<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a Module
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.name"
                outlined
                label="Module Name *"
                prepend-inner-icon="mdi-cube-outline"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="createModule()"
            :loading="isCreating"
            :disabled="isCreating"
          >
            {{ isCreating ? 'Creating...' : 'Create Module' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";

export default {
  name: "CreateModulePage",
  data() {
    return {
      form: {
        name: "",
        is_active: true,
      },
      isCreating: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters['errors/getErrors'];
    }
  },
  methods: {
    async createModule() {
      try {
        this.isCreating = true;
        const response = await axios.post("/modules", this.form);
        if (response.data.success) {
          this.$router.push("/modules");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isCreating = false;
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  margin: 20px 0;
}
</style>